<script setup lang="ts">
import Badge from '@ui/components/badge.vue';
import Icon from '@ui/components/icon.vue';
import { computed } from 'vue';
import { useHelp } from './useHelp';

const {
    isArticleSection,
    isSupportSection,
    helpData,
    externalArticleUrl,
    currentContentType,
    goBackToMenu,
    closeHelpPanel,
} = useHelp();

const texts = computed(() => helpData.value.texts.common);
const showNewsBadge = computed(() => currentContentType.value === 'news');
const newsBadgeText = computed(() => texts.value.news_badge ?? 'News');
</script>

<template>
    <header class="text-brand-500 z-10 bg-white px-3.5 py-2 shadow ring-1 ring-gray-200/50">
        <div class="flex items-center gap-2 text-xl font-bold">
            <button
                v-if="isArticleSection || isSupportSection"
                type="button"
                class="text-brand-500 hover:text-brand-600 inline-flex cursor-pointer p-0 transition focus:outline-none focus:ring-0"
                @click="goBackToMenu"
            >
                <Icon
                    icon="far fa-chevron-left"
                    class="shrink-0"
                ></Icon>
            </button>
            <Icon
                v-else
                icon="far fa-question-circle"
                class="shrink-0"
            ></Icon>
            <span class="font-brand grow truncate text-gray-900">
                {{ texts.headerTitle }}
            </span>
            <Badge
                v-if="showNewsBadge"
                :text="newsBadgeText"
                size="medium"
                theme="light-yellow"
                outlined
                class="-my-1 shrink-0"
            ></Badge>
            <a
                v-if="externalArticleUrl"
                :href="externalArticleUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="inline-flex cursor-pointer p-0 text-gray-400 no-underline transition duration-100 hover:text-gray-800 focus:outline-none focus:ring-0"
            >
                <Icon
                    icon="far fa-external-link"
                    class="shrink-0"
                ></Icon>
            </a>
            <button
                type="button"
                class="inline-flex cursor-pointer p-0 text-gray-400 transition duration-100 hover:text-gray-800 focus:outline-none focus:ring-0"
                @click="closeHelpPanel"
            >
                <Icon
                    icon="far fa-xmark"
                    class="shrink-0"
                ></Icon>
            </button>
        </div>
    </header>
</template>
